/**
 * NOLAS 2026, (c) Mikaël FOURNY.
 * src/i18n/fr.exportDossier.ts
 *
 * Messages de l'écran « Dossier exposants et animateurs »
 * (/admin/export-dossier). Fusionné dans fr.ts. Un seul bloc, dans un
 * fichier dédié, pour ne rien mélanger aux autres chantiers.
 *
 * Mikael - chef de projet - 2026-09-30
 * Portage flotte : coordonnées par rôle, variante sans module emploi, plus
 * de message « dégradé ». Mikael - chef de projet - 2026-10-01
 */
export const messagesExportDossierFr: Record<string, string> = {
  'adminNav.exportDossier': 'Dossier exposants et animateurs',
  'acces.titre.adminExportDossier': 'Dossier exposants et animateurs',

  'exportDossier.titre': 'Dossier exposants et animateurs',
  'exportDossier.sousTitre':
    'Une archive ZIP avec tous les exposants et tous les animateurs, un dossier pour chacun : logo, fiche, contacts, réseaux, une offre ou {lexWorkshopIndef} par fichier. Pratique pour transmettre le dossier complet à un partenaire.',
  'exportDossier.verification': 'Vérification de vos droits…',
  'exportDossier.sansDroit':
    'Vous n’avez pas le droit « Dossier exposants et animateurs ». Il s’accorde dans Contrôle d’accès, par rôle ou par compte.',
  'exportDossier.chargement': 'Lecture des exposants et des animateurs…',
  'exportDossier.erreur.resume': 'Impossible de lire le contenu du dossier. Réessayez dans un instant.',
  'exportDossier.erreur.generique':
    'La génération du dossier a échoué. Réessayez dans un instant ; si le problème persiste, prévenez l’administrateur du site.',

  'exportDossier.stat.exposants': 'Exposants',
  'exportDossier.stat.offres': 'Offres d’emploi',
  'exportDossier.stat.animateurs': 'Animateurs',
  'exportDossier.stat.ateliers': '{lexWorkshopPluralCap}',
  'exportDossier.logos':
    'Logos d’exposants fournis : {logos} sur {exposants}. Animateurs avec logo ou photo : {visuels} sur {animateurs}. Les manquants sont listés dans le fichier LISEZMOI.',
  'exportDossier.coordonnees.oui': 'Les coordonnées personnelles (courriels, téléphones) seront incluses.',
  'exportDossier.coordonnees.non':
    'Les coordonnées personnelles (courriels, téléphones) ne seront PAS incluses : elles sont réservées aux rôles administrateur.',

  'exportDossier.contenu.titre': 'Ce que contient l’archive',
  'exportDossier.contenu.lisezmoi':
    'LISEZMOI.md : date et heure de l’extraction, nombres, conventions, logos et photos manquants.',
  'exportDossier.contenu.index':
    'index-exposants.csv et index-animateurs.csv : une ligne par dossier, à ouvrir dans un tableur.',
  'exportDossier.contenu.exposants':
    'exposants/nom-de-l-entreprise/ : logo d’origine, fiche, contacts, réseaux, un fichier par offre, données brutes.',
  // Flotte : sans module emploi (cirfa), aucune offre n'est écrite. Mikael - chef de projet - 2026-10-01
  'exportDossier.contenu.exposants.sansEmploi':
    'exposants/nom-de-l-entreprise/ : logo d’origine, fiche, contacts, réseaux, données brutes.',
  'exportDossier.contenu.animateurs':
    'animateurs/nom-de-l-animateur/ : logo ou photo, fiche, contact, un fichier par {lexWorkshopBare}, données brutes.',

  'exportDossier.bouton': 'Générer et télécharger le ZIP',
  'exportDossier.bouton.enCours': 'Génération en cours…',
  'exportDossier.generation': 'Le dossier est en cours de préparation, cela peut prendre quelques secondes.',
  'exportDossier.fini': 'Dossier téléchargé : {fichier}',
  'exportDossier.journal':
    'Chaque export est inscrit au journal de l’organisation, à votre nom. Cinq exports au plus par quart d’heure.',
};
